import { trans } from "@mongez/localization";
import { addressesAtom, useDeleteAddress } from "core/addresses";
import { createPortal } from "core/shared";
import { LocationEditIcon } from "lucide-react";
import { Button, errorToast, successToast } from "~/design-system/components";
import { Portal } from "~/modules/shared/components";

export const deleteAddressPortal = createPortal("delete-address-portal");

export function DeleteAddressPortal() {
  const { address } = deleteAddressPortal.useData();
  const { deleteAddressSubmit } = useDeleteAddress(address?.id, {
    onSuccess: (data) => {
      successToast(trans("addressDeletedSuccessfully"));
      addressesAtom.update(data.addresses);
      deleteAddressPortal.close();
    },
    onError: (error: any) => {
      errorToast(error);
    },
  });

  return (
    <Portal portal={deleteAddressPortal} width={550}>
      <div className="flex flex-col items-center justify-center gap-2">
        <span className="text-primary-default flex size-16 items-center justify-center rounded-full border border-black">
          <LocationEditIcon className="size-6" />
        </span>
        <h3 className="text-2xl font-bold">{trans("deleteAddress")}</h3>
        <p className="text-lg font-medium text-black/40">
          {trans("deleteAddressMessage")}
        </p>
        <div className="mt-4 flex w-full flex-wrap items-center gap-4">
          <Button
            onClick={deleteAddressPortal.close}
            className="flex-1 justify-center rounded-full border bg-[#DFDFDF] px-6 py-3 hover:bg-[#d3d3d3]"
          >
            {trans("cancel")}
          </Button>
          <Button
            onClick={deleteAddressSubmit}
            className="bg-primary-light hover:bg-primary-300 flex-1 justify-center rounded-full border px-6 py-3"
          >
            {trans("delete")}
          </Button>
        </div>
      </div>
    </Portal>
  );
}
